import request from '@/utils/axios.js'
import axios from 'axios'
// 获取id 记录
export function Operator (params){
    return request({
        url:'/api/contract/info',
        method:'get',
        params
    });
}

// 生成 合同id 记录
export function Generated (data){
    return request({
        url:'/api/contract/createContract',
        method:'post',
        data
    });
}

// 提交文件数据
export function FileSubmit (data){
    return request({
        url:'/api/contract/edit',
        method:'post',
        data
    });
}

// 提交文件数据
export function FileSave (data){
    return request({
        url:'/api/contract/save',
        method:'post',
        data
    });
}

const departmentApiBase = process.env.VUE_APP_DEPARTMENT_API_BASE_URL || (
    process.env.NODE_ENV === 'development'
        ? 'http://192.168.1.155:8093'
        : 'https://pactapi.naaeus.com'
);

async function departmentRequest (path, config = {}) {
    try {
        return await request({
            ...config,
            url: `${departmentApiBase}${path}`,
            timeout: 120000
        });
    } catch (error) {
        if (!error.response || error.response.status !== 404) throw error;
        return request({
            ...config,
            url: `${departmentApiBase}/index.php${path}`,
            timeout: 120000
        });
    }
}

// 创建“小留之家”签署任务。成功后只使用 union_id 进入填写页。
export function CreateDepartmentDocument (data){
    return departmentRequest('/api/department_document/create', {
        method: 'post',
        data
    });
}

// 按 union_id 获取任务信息及已保存内容。
export function GetDepartmentDocument (unionId){
    return departmentRequest('/api/department_document/info', {
        method: 'get',
        params: { union_id: unionId }
    });
}

// 按 union_id 提交或更新“小留之家”签署内容。
export function SubmitDepartmentDocument (data){
    return departmentRequest('/api/department_document/submit', {
        method: 'post',
        data
    });
}

// STS 接口没有 code/msg/data 包装，因此不经过项目的业务响应拦截器。
export async function GetDepartmentStsToken (){
    try {
        const response = await axios.get(`${departmentApiBase}/api/sts_token/getStsTokenOne`, {
            timeout: 30000
        });
        return response.data;
    } catch (error) {
        if (!error.response || error.response.status !== 404) throw error;
        const response = await axios.get(`${departmentApiBase}/index.php/api/sts_token/getStsTokenOne`, {
            timeout: 30000
        });
        return response.data;
    }
}
